import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class BuildingService { 
  baseUrl = environment.baseUrl;
  
  constructor(
    private http: HttpClient, 
  ) { }

  getBuildingTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'building-types?uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/buildings/?building_id=4329&uuid=30be9ac7-6201-5eda-bb47-d22c7ec39ef7
  getBuilding$(uuid: string, buildingId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.buildings}`;
    return this.http.get<any>(url + '?building_id=' + buildingId + '&uuid=' + uuid);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/buildings/?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  createBuilding$(uuid: string, buildingInfos: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.post<any>(url + '?uuid=' + uuid, buildingInfos, httpOptions);
  }

  // https://dk90qm7un1jgu.cloudfront.net/api/buildings/?uuid=2ecfc289-2c45-5fb0-9b16-cd97a6ce22a5
  updateBuilding$(uuid: string, buildingInfos: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.buildings}`;
    return this.http.put<any>(url + '?uuid=' + uuid, buildingInfos, httpOptions);
  }
}